import React, { Component } from 'react'
import { connect } from 'react-redux'
import MiniCart from '../Components/MiniCart'
import {
    toggle,
    update as updateOrderRowQuantity,
} from '../Actions/Cart.action'

class MiniCartContainer extends Component {
    constructor(props) {
        super(props)
        this.clickHandler = this.clickHandler.bind(this)
        this.lastClickedNode = null
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickHandler)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler)
    }

    render() {
        let containerClasses = 'cart cart--mini'
        containerClasses += this.props.showInfo ? ' cart--mini--open' : ''
        return (
            <div
                className={containerClasses}
                ref={(elem) => (this.miniCartContainer = elem)}
                onMouseDown={(e) => this.clickHandler(e)}
            >
                <MiniCart {...this.props} />
            </div>
        )
    }
    clickHandler(event) {
        const { showInfo, toggle } = this.props
        if (
            this.miniCartContainer &&
            !this.miniCartContainer.contains(event.target)
        ) {
            showInfo && toggle()
        }
    }
}

const mapStateToProps = (state) => {
    const { cart } = state
    return {
        ...cart,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggle: () => dispatch(toggle()),
        removeOrderRow: (rowId) => dispatch(updateOrderRowQuantity(rowId, -1)),
        updateOrderRowQuantity: (rowId, quantity) =>
            dispatch(updateOrderRowQuantity(rowId, quantity)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniCartContainer)
